// extracted by mini-css-extract-plugin
export default {"state-style":"afterSale_state-style__v4Udj","state-color":"afterSale_state-color__8fQIJ","inline":"afterSale_inline__uAu+b","width-50":"afterSale_width-50__lrWKO"};